let deepLink = (url) => `https://metamask.app.link/dapp/${url}`;

export const ifMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

export default deepLink;
